export default function isDev() {
  switch (process.env.REACT_APP_STAGE) {
    case 'dev': // <-- We use this in pipelines
    case 'bitbucket-pipeline': // Used by pptr tests in pipelines webapp_build.sh
    case 'development': // <-- enable for local sentry testing
    case 'development-minified':
      return true;
    default:
      return false;
  }
}
